import { FETCH_ALL, FETCH_ONE } from "../stores/action-types";

export default {
    // module assets
    namespaced: true,
    state: {
        item: {},
        items: []
     },

    getters: {

        [FETCH_ONE]: state => {

            return state.item;
        },
    },

    actions: {

        [FETCH_ALL] ({commit}, items) {

           commit(FETCH_ALL, items);
        },

        setPatient({commit}, item) {
            commit(FETCH_ONE, item);
        },

        resetPatient({commit}) {
            commit(FETCH_ONE, {});
        },
    },

    mutations: {

        [FETCH_ALL] (state, items) {

            state.items = items;
        },
        [FETCH_ONE] (state, item) {
            
            state.item  = item;
        }
    },
}
